import MapViewItemBase from '~/client/src/shared/components/SitemapHelpers/models/MapViewItemBase'
import MapViewItemFactory from '~/client/src/shared/components/SitemapHelpers/models/MapViewItemFactory'
import MapViewItemType from '~/client/src/shared/enums/MapViewItemType'
import GlobeView from '~/client/src/shared/models/GlobeView'
import LocationBase from '~/client/src/shared/models/LocationObjects/LocationBase'
import Sitemap from '~/client/src/shared/models/Sitemap'
import SitemapItem from '~/client/src/shared/models/SitemapItem'

import { planMapViewItems } from './planMapViewItems'

type ProjectEditableMapView =
  | { readonly kind: 'globe'; readonly map: GlobeView }
  | { readonly kind: 'sitemap'; readonly map: Sitemap }

interface IProjectMapViewItemsArgs {
  readonly mapView: ProjectEditableMapView
  readonly projectId: string
  readonly attributes: readonly LocationBase[]
  readonly sitemapItems: readonly SitemapItem[]
  readonly displaySources: readonly (GlobeView | Sitemap)[]
  readonly allowedDatalessItemTypes: readonly MapViewItemType[]
}

/** Projects persistent editor rows without mutating source domain objects. */
export function projectMapViewItems({
  mapView,
  ...input
}: IProjectMapViewItemsArgs): MapViewItemBase[] {
  return planMapViewItems({ mapView, ...input }).map(plan => {
    const attributeCopy = plan.attribute?.copy() ?? null
    const placementCopy =
      plan.kind === 'existing'
        ? plan.placement.copy()
        : new SitemapItem(
            null,
            plan.attribute.name,
            plan.attribute.color,
            null,
            null,
            plan.projectId,
            plan.attribute.id,
          )

    return mapView.kind === 'globe'
      ? MapViewItemFactory.fromGlobeItem(
          attributeCopy,
          placementCopy,
          mapView.map,
        )
      : MapViewItemFactory.fromSitemapItem(
          attributeCopy,
          placementCopy,
          mapView.map,
        )
  })
}
